import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { BufferService, LoadingContext, M_Button, M_Header, NavigateContext } from "src/M_Components"
import { ShippingConditionInfo } from "./components/ShippingConditionInfo"


export const ShippingConditionDetail = ({ roles }) => {
    const ctx = useContext(LoadingContext)
    const navigateCtx = useContext(NavigateContext)
    const { t } = useTranslation()

    const shippingConditionService = new BufferService("ShippingCondition")

    const [data, setData] = useState({})
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [tabId, setTabId] = useState(sessionStorage.getItem("selectedTab"))
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState()

    const sessionKeys = ["operation", "data", "open", "passedRow"];

    useEffect(() => {
        const passOperation = ctx.passValue.get("operation");
        setOperation(passOperation);

        if (isFirstTime) {
            ctx.setIsLoad(true);
            getSessionStorageData(tabId);
            setIsFirstTime(false);
            sessionStorage.setItem(`tab${tabId}`, JSON.stringify(sessionKeys));
        }
    }, []);

    useEffect(() => {
        const newId = sessionStorage.getItem("selectedTab");
        if (newId !== tabId) {
            setTabId(newId);
            getSessionStorageData(newId);
        }
    }, []);

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(tabId, key, key);
        });
        // eslint-disable-next-line
    }, [tabId, data]);

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
            return;
        if (eval(value) instanceof String && eval(value) === "") return;
        if (eval(value) instanceof Number && eval(value) === "") return;

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(
                `${id}${key}`,
                JSON.stringify(Array.from(eval(value))),
            );
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)));
        }
    };

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`));
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`));
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`));
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`));

        if (
            (tempO && tempO !== "") ||
            (tempD && Object.keys(tempD).length !== 0) ||
            tempOS ||
            (tempPR && Object.keys(tempD).length !== 0)
        ) {
            setData(new Object(tempD));
            setPassedRow(tempPR);
            setOperation(tempO)
            ctx.setIsLoad(false);

            return;
        }

        get();
    };

    const get = () => {
        if(ctx.passValue.get("operation") === 'create') {
            ctx.setIsLoad(false)
            return
        }

        shippingConditionService
            .getId(ctx.passValue.get('row').Id)
            .then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages(
                        "error",
                        t("Error"),
                        response?.response?.data?.Errors || response.message,
                    );
                    ctx.setIsLoad(false);
                    return;
                }

                setData(response);

                ctx.setIsLoad(false);
            })
            .catch((err) => {
                ctx.toastMessages("error", err.message, "Error");
                ctx.setIsLoad(false);
            });

        ctx.setIsLoad(false);
    };

    const save = () => {
        ctx.setIsLoad(true);

        if (operation === "create") {
            shippingConditionService.post(data).then((response) => {
                if (response.name === "AxiosError") {
                    const data = response?.response?.data

                    ctx.toastMessages(
                        "error",
                        t("ErrorCreating"),
                        data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
                    );
                    ctx.setIsLoad(false);
                } else {
                    ctx.toastMessages(
                        "success",
                        t("Success"),
                        t("CreatedShippingCondition"),
                    );
                    ctx.setIsLoad(false);

                    navigateCtx.closeTab(tabId.replace(/"/g, ''))
                }
            });
        } else if (operation === "edit") {
            shippingConditionService.update(data.Id, data).then((response) => {
                if (response.name === "AxiosError") {
                    const data = response?.response?.data

                    ctx.toastMessages(
                        "error",
                        t("ErrorUpdating"),
                        data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
                    );
                    ctx.setIsLoad(false);
                } else {
                    ctx.toastMessages(
                        "success",
                        t("Success"),
                        t("EditedShippingCondition"),
                    );
                    ctx.setIsLoad(false);

                    navigateCtx.closeTab(tabId.replace(/"/g, ''))
                }
            });
        }
    };

    return <div>
        <M_Header
            element={
                <>
                    <M_Button
                        tooltip={t("Back")}
                        label={t("Back")}
                        icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                        onClick={() => { }}
                    />
                    <M_Button
                        tooltip={t("Save")}
                        icon={<img src='/icons/svgsDaNet/download.svg' style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)', width: '20px' }} className='downloadPdf' alt='DownloadPdf' />}
                        label={t("Save")}

                        onClick={() => { save() }}
                    />
                </>
            }
        />
        <div>
            <ShippingConditionInfo dataState={data} setDataState={setData} />
        </div>
    </div>
}
